import Firebase from '../../../firebase';
import { PROCEDURE_COLLECTION } from '../../../firebase/collections';

const collection = Firebase.db.collection(PROCEDURE_COLLECTION);

export const requestAddProcedure = async ({ ...restProps }) => {
  return await collection.add({ ...restProps }).then((docRef) => docRef.id);
};

export const requestEditProcedure = async ({ id, ...restProps }) => {
  return await collection.doc(id).update({ ...restProps });
};

export const requestDeleteProcedure = async (id) => {
  return await collection.doc(id).delete();
};

export const requestUpdateProcedureSequence = async (list) =>
  Promise.all(list.map((item, index) => collection.doc(item.id).update({ index: index + 1 })));

export const requestFetchProcedure = async () => {
  return await collection
    .get()
    .then((snapshot) => snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
};
